import _ from 'lodash'
import Backbone from 'backbone'
import appDisplay from 'scoreboard/components/app-display'
import calendars from 'scoreboard/components/calendars'
import conductor from 'scoreboard/components/conductor'
import globals from 'scoreboard/components/globals'
import highlight from 'scoreboard/components/highlight'
import i18n from 'scoreboard/components/i18n'
import changePeriodConfirmationTemplate from './period-change-confirmation.hbs'

const PeriodChangeConfirmation = Backbone.View.extend({
	tagName: 'form',
	className: 'period-confirmation',
	events: {
		'submit': 'submit'
	},
	/**
	 * @param {Number} options.periodId
	 *
	 * @param {String} [options.domainLabel]
	 *
	 * @param {String} [options.message] optionally override the default message
	 */
	initialize(options={}) {
		this.options = options
	},
	render() {
		let {periodId, domainLabel, message} = this.options
		if (_.isNil(message)) {
			const period = calendars.periodsById[periodId]
			message = i18n.get('alerts.periodChange.message',
				highlight(period.label), domainLabel)
		}
		this.$el.append(changePeriodConfirmationTemplate({message}))
		this.$('.submit').focus()
		return this
	},
	submit(e) {
		e.preventDefault()
		this.trigger('submit')
	}
})

/**
 * Navigate directly to the url if the period matches the global period.
 * Or, prompt the user to change periods first.
 *
 * @param {Number} options.periodId The new periodId
 * @param {String} options.url destination url
 * @param {String} [options.domainLabel] The label of the object being navigated to.
 * Required unless message is provided.
 * @param {String} [options.message] optionally override the default message
 */
function periodChange(options = {}) {
	const {periodId, url} = options
	if (periodId
		&& periodId != globals.periodId
		// A period could have been deleted, so just keep the current period
			&& calendars.periodsById[periodId]) {

		const confirmation = new PeriodChangeConfirmation(options)
		appDisplay.dialog(confirmation)
		confirmation.on('submit', () => {
			globals.periodId = periodId
			conductor.navigate(url, {trigger: true})
			confirmation.trigger('done')
		})
	} else {
		conductor.navigate(url, {trigger: true})
	}
}

export default periodChange

periodChange.__filename__ = 'home/alerts/period-change-confirmation.js'
